import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { objToCamelCase } from 'src/utils/case-styles'
import { convertTextEditorStringToObject, DEFAULT_CONTENT, isDailyLogContentString } from 'src/utils/daily-log-content'

export type ContentText = { value: string; style: { [key: string]: string } }
export type DailyLogContent = { globalStyle: { [key: string]: string }; texts: ContentText[] }

@Component({
  selector: 'app-daily-log-content-text',
  templateUrl: './daily-log-content-text.component.html',
  styleUrls: ['./daily-log-content-text.component.scss'],
})
export class DailyLogContentTextComponent implements OnInit, OnChanges {
  @ViewChild('textEditor') textEditor: ElementRef | undefined

  constructor() {}

  @Input() content: string | undefined
  @Input() isEditable = false
  @Output() onContentChange = new EventEmitter<string>()
  parsedContent: DailyLogContent | undefined
  isParsableContent: boolean = false
  defaultGlobalStyles = DEFAULT_CONTENT.globalStyle

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('content') && changes.content.currentValue) {
      const content = changes.content.currentValue
      if (isDailyLogContentString(content)) {
        this.parsedContent = convertTextEditorStringToObject(content)
        this.parsedContent.globalStyle = objToCamelCase(this.parsedContent.globalStyle)
        this.isParsableContent = true
      } else {
        this.isParsableContent = false
      }
    }

    if (changes.hasOwnProperty('isEditable') && changes.isEditable.currentValue) {
      setTimeout(() => {
        // 1️⃣ 포커스를 editor에 줌
        const editorElement = this.textEditor?.nativeElement
        if (!editorElement) return
        editorElement.focus()

        // 2️⃣ 커서를 마지막으로 이동
        const selection = window.getSelection()
        const range = document.createRange()
        range.selectNodeContents(editorElement) // editor의 모든 내용을 선택
        range.collapse(false) // 마지막 위치로 커서를 이동
        selection?.removeAllRanges()
        selection?.addRange(range)
      }, 0)
    }
  }

  // 사용자가 입력할 때마다 업데이트
  onInput(event: Event, value: string): void {
    this.onContentChange.emit(value)
  }

  applyStyle(style, value): void {
    let selection = window.getSelection()
    if (!selection?.rangeCount) return

    let range = selection.getRangeAt(0)
    let span = document.createElement('span')
    span.style[style] = value
    range.surroundContents(span)
  }
}
